// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2dz0X","header":"Messages_header__1pcuk"};